import { createContext } from 'react';

interface ICrisisToolStatus {
  isCrisisToolActive: boolean;
  revalidateCrisisToolStatus: () => Promise<boolean>;
  markCrisisToolDeactivated: () => void;
}

const CrisisToolStatusContext = createContext<ICrisisToolStatus>({
  isCrisisToolActive: true,
  revalidateCrisisToolStatus: async () => true,
  markCrisisToolDeactivated: () => undefined
});

export default CrisisToolStatusContext;
